<template>
    <div class="tradeChart">
        <div id="navTitle">
            <img class="black" @click="back" src="@/assets/images/template/a_top_return.png"/>
            <span>{{quote.notify[code].szShortName}}</span>
        </div>
        <div id="content">
            <Charts :code="code" :isSlider="isSlider" @changeCode="changeCode" v-if="position.SName.szShortName in quote.symbolTickMap"></Charts>
            <div class="orderCon">
                <ul>
                    <li><p>{{$t('success.positionID')}}</p><span>{{position.ID}}</span></li>
                    <li><p>{{$t('success.openingTime')}}</p><span>{{position.OpenTime|time}}</span></li>
                    <li><p>{{$t('trade.products.lot')}}</p><span v-if="position.symbolData">{{position.Volume}}</span></li>
                    <li><p>{{$t('success.openingPrice')}}</p><span>{{position.OpenPrice}}</span></li>
                    <li><p>{{$t('success.commission')}}</p><span v-if="position.Commission">{{position.Commission >= 0?'':'-'}}${{position.Commission>=0?position.Commission.replace("+", ""):position.Commission.replace("-", "")}}</span></li>
                    <li><p>{{$t('success.productDirection')}}</p><span>{{position.Direction==1?$t('trade.products.buy'):$t('trade.products.sell')}}</span></li>
                    <li><p>{{$t('trade.products.floatProfitLoss')}}</p><span>{{profit > 0?'+':'-'}}<em>${{Math.abs(profit)}}</em></span></li>
                    <li><p>{{$t('success.interest')}}</p><span v-if="position.Swap">{{position.Swap > 0?'+':'-'}}${{position.Swap>0?position.Swap.replace("+", ""):position.Swap.replace("-", "")}}</span></li>
                    <li v-if="position.StopLoss != 0"><p>{{$t('trade.products.stopLossPrice')}}</p><span>{{position.StopLoss}}</span></li>
                    <li v-else><p>{{$t('trade.products.stopLossPrice')}}</p><span>{{$t('trade.products.notSet')}}</span></li>
                    <li v-if="position.TakeProfit != 0"><p>{{$t('trade.products.stopProfitPrice')}}</p><span>{{position.TakeProfit}}</span></li>
                    <li v-else><p>{{$t('trade.products.stopProfitPrice')}}</p><span>{{$t('trade.products.notSet')}}</span></li>
                </ul>
            </div>
            <div class="btn">
                <span @click="clickPosPop" :class="position.ID?'':'err'">{{$t('trade.products.closePosition')}}</span>
                <span @click="clickModifyPop" :class="position.ID?'':'err'">{{$t('trade.products.modifyStopLoss')}}</span>
            </div>
            <RightFloat></RightFloat>
            <PositionPop ref="child" v-if="isPositionPop" :position="position" :code="code"></PositionPop>
            <ModifyStopLoss ref="child1" v-if="isModifyPop" :position="position" :code="code"></ModifyStopLoss>
        </div>
        <tab></tab>
    </div>
</template>
<script>
    require('@/assets/css/tradeChart.css');
    import VeCandle from 'v-charts/lib/candle.common'
    import Tab from '@/view/module/Tab.vue'
    import RightFloat from '@/view/module/RightFloat.vue'
    import Charts from '@/view/quotation/Charts'
    import PositionPop from '@/view/trade/tradePop/PositionPop'
    import ModifyStopLoss from '@/view/trade/tradePop/ModifyStopLoss'
    import {mapState} from 'vuex'
    import Util from '@/utils/tradeDataUtil'
    import TradeUtil from '@/utils/tradeUtil'
    import Constant from '@/utils/Constant'
    export default {
        name: "PositionChart",
        components: {
            Tab,VeCandle, Charts, PositionPop, ModifyStopLoss,RightFloat
        },
        filters: {
            time(longTime) {
                return Util.formatDate(longTime,"MM/dd hh:mm:ss");
            }
        },
        computed:{
            ...mapState(['tradeData', 'quote', 'socket', 'account']),
            position:{
                get(){
                    if (this.tradeData.position && this.tradeData.position.length > 0){
                         for (const i in this.tradeData.position) {
                             if (this.tradeData.position[i].ID == this.id){
                                 return TradeUtil.copy(this.tradeData.position[i]);
                             }
                         }
                    }
                    return {};
                }
            },
            closePrice: {
                get() {
                    if (!this.position.SName || !this.quote.symbolTickMap[this.position.SName.szShortName]) return "";
                    return this.position.Direction == 1 ? this.quote.symbolTickMap[this.position.SName.szShortName].ask : this.quote.symbolTickMap[this.position.SName.szShortName].bid;
                }
            },
            /*盈亏*/
            profit: {
                get() {
                    if (this.position.symbolData) {
                        // 确保tick数据已存在
                        if( this.position.SName.szShortName in this.quote.symbolTickMap){
                            const ask = this.quote.symbolTickMap[this.position.SName.szShortName].ask;
                            const bid = this.quote.symbolTickMap[this.position.SName.szShortName].bid;
                            let sub = Util.accSub(this.closePrice, this.position.OpenPrice);
                            if (this.position.Direction == 2) sub = Util.accSub(this.position.OpenPrice, this.closePrice);
                            const profit = Util.accAdd(TradeUtil.changeCurrency(sub, ask, bid, this.position.Volume, this.position.symbolData, this.quote.symbolTickMap, this.position.Direction), this.position.Swap);
                            return Number(profit).toFixed(2);
                        }
                    }
                    return "";
                }
            },
        },
        data() {
            return {
                code: this.$route.query.id || "",
                id: this.$route.query.positionId || "",
                util:Util,
                isPosition: false,
                isModify: false,
                isSlider: false,
                isModifyPop:false,
                isPositionPop:false
            }
        },
        methods: {
            changeCode(code) {
                this.code = code;
                this.$router.replace({path: "/home/positionChart", query: {id: code}});
            },
            GetUrlParam(paraName) {
                let url = document.location.toString();
                let arrObj = url.split("?");
                if (arrObj.length > 1) {
                    let arrPara = arrObj[1].split("&");
                    let arr;
                    for (let i = 0; i < arrPara.length; i++) {
                        arr = arrPara[i].split("=");

                        if (arr != null && arr[0] == paraName) {
                            return arr[1];
                        }
                    }
                    return "";
                } else {
                    return "";
                }
            },
            back() {
                this.$router.go(-1);
            },
            clickPosPop() {
                if(!this.position.ID)return;
                this.isPositionPop = true;
                this.$nextTick(()=>{
                    this.$refs.child.clickPosPop();
                });
            },
            clickModifyPop() {
                if(!this.position.ID)return;
                this.isModifyPop=true;
                this.$nextTick(()=> {
                    this.$refs.child1.clickModifyPop();
                })
            },
        },
        mounted(){
            this.$bus.$emit('loading', true);
            let mainH = document.getElementById("main");
            mainH.classList.remove('mainFixed');
        },
        activated(){
            this.$bus.$emit('loading', true);
        },
        created(){
            var productList = process.env.VUE_APP_PRODUCTS.split(",")
            if(!productList.includes(this.code)){
                productList.push(this.code);
                //订阅数据字典有的数据
                this.socket.quoteSocket.emit('request', Number(Constant.Req.subsTick), {
                    "UserID": this.account.userId,
                    "GroupID": this.account.groupId,
                    "uiCodeIDList": productList
                });
                //分页请求数据字典中数据的最后一口报价(个人猜测:一次请求产品不能超过15个,否则请求失效)
                let lastTick = {};
                for (const i in productList) {
                    lastTick[i] = productList[i];
                }
                this.socket.quoteSocket.emit('request', Number(Constant.Req.lastTick), lastTick);
            }
        }

    };
</script>
